export default __webpack_public_path__ + "static/media/1.48654d71.jpg";